import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationScanRunTriggerArgs, ScanRun } from "types/generated";

type ScanRunTriggerData = {
  scanRunTrigger: Pick<ScanRun, "id">;
};

export const SCAN_RUN_TRIGGER: TypedDocumentNode<ScanRunTriggerData, MutationScanRunTriggerArgs> =
  gql`
    mutation ScanRunTrigger($scan: ID!) {
      scanRunTrigger(scan: $scan) {
        id
      }
    }
  `;
